import React, { useMemo } from 'react';
import key from 'weak-key';
import Accordion from 'react-bootstrap/Accordion';

import { itemInformationTransform } from '../utils/transform-data';
import Card from './card/card';
import { type IResultContext, useDfContext } from '../context/df-context';

export default function AccordionResults(): React.ReactElement | null {
  const {
    state: { expandedCard, productPageResults },
  } = useDfContext<IResultContext>();

  const sortedResults = useMemo(() => {
    return productPageResults?.reduce((prev, cur) => {
      return {
        ...prev,
        [cur.category]: prev[cur.category] ? [...prev[cur.category], cur] : [cur],
      };
    }, {});
  }, [productPageResults]);

  return (
    <section className="df-accordion">
      <Accordion className="accordion--icon-left" alwaysOpen>
        {sortedResults ? (
          Object.entries(sortedResults).map(([title, items]) => {
            const collapseId = key(items as any[]);
            return (
              <Accordion.Item key={collapseId} eventKey={collapseId}>
                <Accordion.Header>{title}</Accordion.Header>
                <div className="df-product-downloads__group">
                  <Accordion.Body className="df-list-module-row">
                    {(items as any[])?.map((group) => (
                      <Card
                        key={key(group)}
                        {...group}
                        {...itemInformationTransform(group)}
                        expanded={expandedCard === group.pimId}
                      />
                    ))}
                  </Accordion.Body>
                </div>
              </Accordion.Item>
            );
          })
        ) : (
          <></>
        )}
      </Accordion>
    </section>
  );
}
